// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__H2RJG","pink":"About_pink__Gigno","green":"About_green__Ao5qb","skills":"About_skills__C2-Cs"};